'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextArea from 'UIComponents/input/UITextArea';
import { SHARE_EMAIL } from '../shareTypes';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const getHeaderText = currentDialog => {
  switch (currentDialog) {
    case SHARE_EMAIL:
      return 'reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailMessageLabel';
    default:
      return 'reporting-action-components.actions.shareVia.dialog.form.formSection.messageLabel';
  }
};
const ShareMessageTextInput = () => {
  const {
    currentDialog,
    message,
    setMessage
  } = useControlsContext();
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getHeaderText(currentDialog)
    }),
    children: /*#__PURE__*/_jsx(UITextArea, {
      defaultValue: message,
      onChange: e => setMessage(getEventValue(e))
    })
  });
};
export default ShareMessageTextInput;